"use strict";

// The global client bundle (esbuild -> server/_public/js/app.js).

// Connects to socket.io and re-emits task events as DOM events.
require('./realtime.js');
// Project chat: the composer, mentions, attachments and live appends on Home.
require('./communication.js');
// Tag input (common component): pills + type-to-suggest, on the task panel.
require('../../common/components/js/tag-input.js');
// Project settings in the panel: show-when and on-demand fragments.
require('./settings.js');
// App shell: sidebar, counts, right panel, AJAX forms.
require('./shell.js');
// Entity-header overflow menu (3-dot trigger at narrow widths).
// Project Home: the live thread (General or a DM).
require('./project-home.js');
